module.exports = __webpack_public_path__ + "static/media/ios-cafe.89e90031.svg";